@if (prefixSuffix().icon) {
  <crnt-icon [icon]="prefixSuffix().icon"></crnt-icon>
}
@if (prefixSuffix().text) {
  <div [innerHTML]="prefixSuffix().text"></div>
}
